import styled from "styled-components";
import { media } from "../../theme";

export const AuthContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100vh;
    background-color: ${({theme}) => theme.palette.background.default};
    padding: 16px;

    ${media.sm} {
        padding: 24px;
    }

    ${media.md} {
        padding: 36px;
    }
`;
